<template>
  <div class="cls-platform">
    <!-- 搜索 -->
    <div class="cls-platform__top">
      <el-input
        class="cls-platform__top__input"
        placeholder="请输入内容"
        prefix-icon="el-icon-search"
        v-model="searchInput"
        @blur="getUserList">
      </el-input>
      <el-button class="cls-platform__top__button" type="primary" @click="handleAddUser">添加用户</el-button>
    </div>
    <!-- 列表 -->
    <el-table
      class="cls-platform__table"
      ref="multipleTable"
      :data="userList"
      tooltip-effect="dark"
      style="width: 100%"
      max-height="800px"
    >
      <el-table-column label="用户名" prop="userName" min-width="50"></el-table-column>
      <el-table-column label="角色" prop="userTypeName" min-width="50"></el-table-column>
      <el-table-column label="机构" prop="organization" min-width="100"></el-table-column>
      <el-table-column label="创建时间" prop="createTime" min-width="80"></el-table-column>
      <el-table-column label="更新时间" prop="updateTime" min-width="80"></el-table-column>
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" style="color: #0000ff;" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button 
            size="mini" 
            :style="scope.row.disable === 1 ? 'color: #0e0e0fe5;' : 'color: #0000ff;'" 
            @click="handleDisable(scope.row)"
          >
            {{scope.row.disable === 1 ? '生效' : '禁用'}}
          </el-button>
          <el-button size="mini" style="color: #ff0000;" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页功能 -->
    <el-pagination
      class="cls-platform__pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="sizePage"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalPage">
    </el-pagination>
    <!-- 添加或编辑用户model -->
    <AddUser :visible="saveVisible" :rowData="rowData" @saveUserAfter="saveUserAfter"></AddUser>
  </div>
</template>
<script>
import AddUser from '../components/user/Add-User.vue'
export default{
  name: 'Platform-Account',
  components: {
    AddUser,
  },
  data() {
    return {
      saveVisible: false, // 保存用户
      searchInput: '',
      rowData: {},
      userList: [],
      totalPage: 0, // 默认总数据为0
      sizePage: 10, // 默认每页10条数据
      currentPage: 1 // 默认展示第一页数据
    };
  },
  methods: {
    handleAddUser(){
      this.saveVisible = true
      this.rowData = {}
    },
    handleEdit(row) {
      this.saveVisible = true
      this.rowData = row
    },
    handleDisable(row) {
      this.$http.post('/aigenai/user/disableOrEnable',  {id: row.id}).then(
        res=>{
          if (res.code !== 0) return
          this.userList.map(item=>{
            if (item.id === row.id) {
              item.disable = item.disable === 1 ? 0 : 1
            }
          })
        }
      ).catch(err=>{console.log('err', err)})
    },
    // 删除用户
    handleDelete(row) {
      this.$confirm(`确认删除用户“${row.userName}”?`, '删除用户', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        // 删除用户
        this.$http.post('/aigenai/user/delete',  {id: row.id}).then(
          res=>{
            if (res.code !== 0) return
            this.getUserList()
          }
        ).catch(err=>{console.log('err', err)})
      }).catch(()=>{
        this.$message({ type: 'info', message: '取消删除' });  
      })
    },
    // 获取用户列表
    getUserList(){
      let data = {params: {size: this.sizePage, current: this.currentPage, keyword: this.searchInput}}
      this.$http.get('/aigenai/user/getUserList', data).then(
        res => {
          if (res.code !== 0) {return}
          this.userList = []
          this.userList.push(...res.data.records)
          this.totalPage = res.data.total
        }
      )
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.sizePage = val
      this.getUserList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val
      this.getUserList()
    },
    // 保存用户之后操作
    saveUserAfter(userForm) {
      this.saveVisible = false
      this.getUserList()
    }
  },
  mounted() {
    this.getUserList()
    this.$bus.$on('closeSaveUser', (visible)=>{this.saveVisible = visible})
  },
  beforeDestroy() {
    // 销毁保存用户组件
    // this.$bus.$off('saveUser');
    this.$bus.$off('closeSaveUser');
  },
}
</script>
<style lang="less" scoped>
@import url(../style/my-element.less);
.cls-platform{
  position: relative;
  width: 80%;
  top: 100px;
  left: 300px;
  right: 0px;
  bottom: 50px;
  &__top{
    display: flex;
    &__button{
      border-radius: 0px;
    }
  }
  &__table{
    width: 100%;
    margin-top: 0px;
  }
  &__pagination {
    margin-top: 10px;
  }
}
</style>